export function checkIfAllowedHost(hostname: string) {
  const normalizedHostname = hostname.toLowerCase().replace(/\.$/, '');
  const parentDomain = normalizedHostname.split('.').slice(-2).join('.');

  const isListedHost = ALLOWED_HOSTS.includes(normalizedHostname);
  const isListedParentDomain = ALLOWED_PARENT_DOMAINS.includes(parentDomain);

  return isListedHost || isListedParentDomain;
}

// ─── Helpers ─────────────────────────────────────────────────────────────────

function decodeBase64(value: string) {
  return atob(value);
}

// ─── Constants ───────────────────────────────────────────────────────────────

const ALLOWED_HOSTS = [
  'b3JkZXIuc3dlZXRncmVlbi5jb20=',
  'b3JkZXItZGV2ZWxvcG1lbnQuc3dlZXRncmVlbi5jb20=',
  'ZDl4bW53dGY3OHIxeS5jbG91ZGZyb250Lm5ldA==',
  'bG9jYWxob3N0',
].map(decodeBase64);

const ALLOWED_PARENT_DOMAINS = ['c3dlZXRncmVlbi5kZXY='].map(decodeBase64);
